import { eventBus, EnumEventBus } from "./EventBus";
import BaseSliderManager from "../../../../../src/managers/BaseSliderManager/BaseSliderManager";
import Checkbox from "../../../../../src/entities/UI/Checkbox/Checkbox";
import { SliderGenProps } from "../../../../../src/types/Interface";
import { PINK_ANGLE_COLORS, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL } from "../types/Config";


const SliderGen: SliderGenProps[] = [
	{
		head: "move chord A",
		colors: {
			bgColor: 0x21D4FE,
			barColor: 0x000000,
			buttonColor: 0x21D4FE
		},
		keepCurrSlider: true,
		onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveChordA, v - 100)
	},
	{
		head: "move chord B",
		colors: {
			bgColor: 0xB5A1FF,
			barColor: 0x000000,
			buttonColor: 0xB5A1FF
		},
		keepCurrSlider: true,
		onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveChordB, v - 100)
	},
	{
		head: "rotate chords",
		subHead: "(select which one to use)",
		colors: {
			bgColor: 0xBFBFBF,
			barColor: 0x000000,
			buttonColor: 0x000000
		},
		onUpdate: (v: number) => eventBus.emit(EnumEventBus.moveCircumPoint, v - 100)
	}
]

const pointName = ["Chord A", "Chord B"];


export default class SliderManager extends BaseSliderManager {
	pointCheckboxes: Checkbox[] = [];
	pointChecklist: boolean[] = Array(2).fill(false);
	constructor() {
		super(SliderGen, SLIDERS_COORD, SLIDERS_COORD_OFFSET_VERTICAL);
		this.addCheckBoxes();

	}
	handleCheckbox(index: number, v: boolean) {
		this.pointChecklist[index] = v;
		eventBus.emit(EnumEventBus.setPointChecklist, this.pointChecklist);
	}
	addCheckBoxes() {
		const coords = getPointCheckboxCoords(this.dim);
		this.pointCheckboxes = Array(2).fill(PINK_ANGLE_COLORS[0]).map((e, eI) =>
			new Checkbox(coords[eI], pointName[eI], e, false, (label: string, v: boolean) => this.handleCheckbox(eI, v)));
		this.dim.WIDTH < this.dim.HEIGHT && this.pointCheckboxes.forEach(cbox => cbox.setScale(.8));
	}
}


function getPointCheckboxCoords(dim: { WIDTH: number, HEIGHT: number }) {
	const coordHorizontal = [{ x: 1135, y: 775 }, { x: 1135, y: 825 }];
	const getCoordHorizontal = (eI: number) => coordHorizontal[eI]
	const getCoordVertical = (eI: number) => ({
		x: dim.WIDTH / 2 + 35 + (eI > 1 ? 150 : 0),
		y: dim.HEIGHT / 2 + 520 + (eI % 2 == 1 ? 40 : 0)
	})
	const coords = Array(2).fill(null).map((e, eI) => dim.WIDTH > dim.HEIGHT ? getCoordHorizontal(eI) : getCoordVertical(eI == 1 ? eI + 1 : eI));
	return coords
}